class PlayedMediaControl {
    constructor(id, played = false) {
        this.id = id; // id do Event ou Alarm
        this.played = played; // Flag Tocou Media
    }
}

export default PlayedMediaControl;